import {Component, Input} from '@angular/core';
import {SwiperOptions} from 'swiper/types';
import {CurrentUserViewModel} from '../../../../../core/models/current-user.view-model';
import {FollowerListItemInterface} from '../../../../../core/interfaces/follower-item.interface';
import {SocialDataProviderService} from '../../../../timeline/social-grid-list/social-data-provider.service';
import {SocialListItemRenderer} from '../social-list-item-renderer.interface';
import {UserViewModel} from '../../../../../features/user/settings/user.view-model';

@Component({
  selector: 'app-follow-list-item',
  templateUrl: './follow-list-item.component.html'
})
export class FollowListItemComponent implements SocialListItemRenderer<FollowerListItemInterface> {
  @Input() public item: FollowerListItemInterface;
  @Input() public currentUser: CurrentUserViewModel;
  @Input() public socialDPS: SocialDataProviderService;
  @Input() public navigateTo: (item: FollowerListItemInterface) => void;
  @Input() public swiperConfig: SwiperOptions;

  public isFollowedByCurrentUser(): boolean {
    return this.socialDPS.isFollowedByCurrentUser(this.item.follower as unknown as UserViewModel);
  }

  public isLikedByCurrentUser(): boolean {
    return this.socialDPS.isLikedByCurrentUser(this.item.follower as unknown as UserViewModel);
  }
}
